"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateEvent = void 0;
// import * as uuid from 'uuid';
class StateEvent {
    constructor(stateNode, config = {
        transitions: []
    }) {
        this.transitions = [];
        // this.id = uuid();
        this.stateNode = stateNode;
        Object.assign(this, config);
    }
    getJsonPath() {
        var _a;
        let path = this.stateNode.getJsonPath();
        const index = (_a = this.stateNode.events) === null || _a === void 0 ? void 0 : _a.indexOf(this);
        if (index === -1) {
            throw new Error('Invalid state event. Cannot resolve event in state node.');
        }
        path += `.events[${index}]`;
        return path;
    }
    toJson() {
        return {
            name: this.name,
            description: this.description,
            isTransient: this.isTransient,
            transitions: this.transitions,
            data: this.data
        };
    }
}
exports.StateEvent = StateEvent;
//# sourceMappingURL=state-event.js.map